export default {
	name: "indexView", // 学员优作
	data() {
		return {
			navList: [],
			groupList: [],
		};
	},
	watch: {},
	created() {
		console.log("student created");
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {
		await this.getGroup();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getGroup() {
			const groupRes = await this.$zkHttp.index$getArticleDesc();
			console.log("groupRes", groupRes);
			this.groupList = groupRes.sort((a, b) => {
				return b.list.length - a.list.length;
			});
		},
		gotoStList(e) {
			this.$router.push({
				name: 'studentList',
				query: {
					group: e
				}
			});
		},
		gotoStDetail(parent, e) {
			this.$router.push({
				name: 'studentDetail',
				query: {
					group: parent,
					articleId: e.id
				}
			});
		}
	},
};